<div class="card-body no-padding-top">
    <ng-content></ng-content>
</div>
